// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hideContent[data-v-b2bc797e] {\n  width: 200px;\n  display: block;\n  overflow: hidden;\n  word-break: keep-all;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.goodsList[data-v-b2bc797e] {\n  display: flex;\n  flex-direction: row;\n  overflow: hidden;\n  height: 100%;\n}\n.goodsList__left[data-v-b2bc797e] {\n  margin: 20px;\n  width: 20%;\n  min-width: 20%;\n  overflow: auto;\n}\n.goodsList__right[data-v-b2bc797e] {\n  flex: 1;\n}", ""]);
// Exports
module.exports = exports;
